<script lang="ts">
	import ReadMore from 'components/ReadMore/ReadMore.svelte';
	import { htmlRegex } from 'utils/regex/html';
	import { timeSince } from 'utils/SocialNetworksUtils/DateTools/DateTools';
	import { _ } from 'svelte-i18n';

	export let dark: boolean;
	export let article: {
		title: string;
		description: string;
		category: string;
		author: string;
		mainImage: string | { text: string };
		_createdAt: string;
		slug: {
			_type: string;
			current: string;
		};
	};
</script>

<a target="_blank" href={`/learn/${article.slug?.current}`} class="card-wrapper" class:dark>
	<div class="image-wrapper">
		{#if !article.mainImage?.text}
			<img src={article.mainImage} alt={article.title} class="image" height={200} />
		{:else}
			<div class="placeholder-body">
				<h2 class="image placeholder">{article.mainImage.text}</h2>
			</div>
		{/if}
		<p class="label">{article.category?.replaceAll('_', ' ')}</p>
	</div>
	<div class="text-wrapper">
		<div class="card-title link">
			{`${article.title.replace(htmlRegex, '').substring(0, 60)} ${
				article.title.length > 60 ? '...' : ''
			}`}
		</div>
		<p class="card-text">
			{`${article.description.replace(htmlRegex, '').substring(0, 160)} ${
				article.description.length > 160 ? '...' : ''
			}`}
		</p>
		<div class="stats">
			<ReadMore
				as="link"
				target="_blank"
				linkTo={`/learn/${article.slug?.current}`}
				label={article.title}
				class="font-12"
			/>
			<div class="data">
				<p class="author">{$_('By')} {article.author}</p>
				&middot
				<p class="time">{timeSince(new Date(article._createdAt))}</p>
			</div>
		</div>
	</div>
</a>

<style lang="scss">
	@import 'articleCard';
</style>
